export const LOGOUT = 'LOGOUT'
export const SET_USER = 'SET_USER'
export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_PASSTHROUGH = 'SET_PASSTHROUGH'
export const SET_ROLES = 'SET_ROLES'
export const SET_SOLUTION = 'SET_SOLUTION'



// WEBPACK FOOTER //
// ./src/store/modules/auth/types.js